/**
 * Session hint (#670).
 *
 * The server sets the readable cookie `gsx8_session_hint=1` next to the
 * httpOnly refresh cookie, with the same lifetime. It carries no secret: it
 * says only that this browser may hold a session that can be resumed from
 * the refresh cookie. A browser without it never asks the refresh route, so
 * an anonymous visitor of the public map costs no extra request.
 *
 * The hint is deleted in exactly two cases: an explicit logout, and a
 * refresh the server answered with 401. A transient failure keeps it.
 */
export const SESSION_HINT_COOKIE = 'gsx8_session_hint';

/** The server writes exactly this pair; an empty leftover value is no hint. */
const HINT_PAIR = `${SESSION_HINT_COOKIE}=1`;

/** True when the hint cookie is present. A throwing `document.cookie` means no hint. */
export function hasSessionHint(): boolean {
  try {
    return document.cookie.split(';').some((part) => part.trim() === HINT_PAIR);
  } catch {
    return false;
  }
}

/**
 * Delete the hint in this browser. The cookie is host-only with path `/`,
 * so the deletion names the same path and no domain.
 */
export function clearSessionHint(): void {
  try {
    document.cookie = `${SESSION_HINT_COOKIE}=; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  } catch {
    // Blocked cookie access: nothing to delete from here.
  }
}
